import type { Note } from 'webmidi';

let NoteClass: typeof Note | null = null;
// eslint-disable-next-line
let isModuleLoading = true;
let moduleLoadAttempts = 0;

const MAX_LOAD_ATTEMPTS = 3;

function loadWebMidiModule() {
  if (!isBrowser()) return;
  
  moduleLoadAttempts++;
  import('webmidi').then(module => {
    NoteClass = module.Note;
    isModuleLoading = false;
  }).catch(err => {
    console.error(`Failed to load webmidi (attempt ${moduleLoadAttempts}):`, err);
    isModuleLoading = false;
    if (moduleLoadAttempts < MAX_LOAD_ATTEMPTS) {
      setTimeout(loadWebMidiModule, 1000); // Retry after 1 second
    }
  });
}

if (isBrowser()) {
  loadWebMidiModule();
}

import { MeasureTimemapEntry } from "@/sharedTypes/main";
import { triggerEvent } from "@/sharedTypes/pureHelpers";
import { ManagerEntity } from "@/shared/globalFunctions";
import { isBrowser } from "@/sharedTypes/browserUtils";
import { dpAssert } from '@/sharedTypes/helpers';

class Pianola {
  enabled: boolean = false;
  withWrongNotes: boolean = false;
  timemap: MeasureTimemapEntry[] | undefined
  constructor() { }

  async play(withWrongNotes: boolean = false) {

    this.enabled = true;
    this.withWrongNotes = withWrongNotes;

    const player = ManagerEntity.player;
    if (player) {
      if (ManagerEntity.selectedPracticeMode?.id === 1) {
        await player.startSelectedMode();
      } else if (ManagerEntity.selectedPracticeMode?.id === 0) {
        setInterval(() => {
          this.pressNotes();
        }, 200)
      }
    }
  }

  async enable(withWrongNotes: boolean = false) {

    this.enabled = true;
    this.withWrongNotes = withWrongNotes;

    ManagerEntity.selectedPracticeMode = ManagerEntity.practiceModes.find((p: any) => p.id === 1);
  }
  async disable() {
    this.enabled = false;
  }
  pressNotes() {
    const core = ManagerEntity.core;
    if (this.enabled && core) {
      const notesToPlay = core.getCurrentNotes();
      if (notesToPlay && notesToPlay.length > 0) {
        const runner = ManagerEntity.player?.runner
        const player = ManagerEntity.player;
        if (runner && player) {
          const currPos = runner.measure.start + runner.measure.offset;
          const notesPos = notesToPlay[0].noteAbsoluteTime;
          if (Math.abs(currPos - notesPos) < 50 || (currPos - notesPos) > 50) {
            // paly notes
            const noteOn = (noteNumber: number) => {
              dpAssert(NoteClass)
              const event = {
                note: new NoteClass(noteNumber)
              }
              player.noteOn(event)
            }
            const noteOff = (noteNumber: number) => {
              dpAssert(NoteClass)
              const event = {
                note: new NoteClass(noteNumber)
              }
              player.noteOff(event)
            }
            function getRandomInt(min: number, max: number) {
              return Math.floor(Math.random() * (max - min + 1)) + min;
            }

            for (const note of notesToPlay) {

              noteOn(note.midi.pitch)
              if (note.ornamentNotes) {
                for (const ornamentNote of note.ornamentNotes) {
                  noteOn(ornamentNote.midi.pitch)
                }
              }

              if (this.withWrongNotes) {
                const randomInt = getRandomInt(0, 4);
                for (let i = 0; i < randomInt; i++) {
                  noteOn(note.midi.pitch + getRandomInt(-6, 6))
                }
              }
            }
            for (const note of notesToPlay) {
              noteOff(note.midi.pitch)
            }
          }
        }
      }
    }
    triggerEvent("pianolaPressNotesFinished")
  }
  pressWrongNote() {
    console.log("press wrong note")
    const core = ManagerEntity.core;

    if (this.enabled && core) {
      const player = ManagerEntity.player;

      if (player) {
        const notesToPlay = core.getCurrentNotes();
        if (notesToPlay && notesToPlay.length > 0) {
          // Get the current note
          const currentNote = notesToPlay[0];
          
          // Generate a wrong note that's different from the current one
          function getRandomInt(min: number, max: number) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          }
          
          // Create a wrong note by shifting the pitch by a random amount (avoiding the correct pitch)
          let wrongPitch;
          do {
            const shift = getRandomInt(-12, 12); // Shift by up to an octave in either direction
            wrongPitch = currentNote.midi.pitch + shift;
          } while (wrongPitch === currentNote.midi.pitch || wrongPitch < 21 || wrongPitch > 108); // Avoid the correct note and stay within piano range
          
          // Play the wrong note
          const noteOn = (noteNumber: number) => {
            dpAssert(NoteClass)
            const event = {
              note: new NoteClass(noteNumber)
            }
            player.noteOn(event)
          }
          
          const noteOff = (noteNumber: number) => {
            dpAssert(NoteClass)
            const event = {
              note: new NoteClass(noteNumber)
            }
            player.noteOff(event)
          }
          
          // Play and then release the wrong note
          noteOn(wrongPitch);
          setTimeout(() => {
            noteOff(wrongPitch);
          }, 200); // Hold the note for 200ms
        }
      }
    }
  }
}
const pianola = new Pianola();
export default pianola
